export class MerchLevel {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default MerchLevel;